import React from "react";
import { Link } from "react-router-dom";
import "./PolicyPage.css";

export default function PrivacyPolicy() {
  return (
    <div className="policy-page">
      <header className="policy-header">
        <div className="policy-header-inner">
          <Link to="/" className="policy-brand">
            <img src="/TechXM-logo.png" alt="TECHXM logo" className="brand-logo-mark" width="30" height="30" />
          </Link>
          <nav className="policy-nav">
            <Link to="/terms-of-service">Terms</Link>
            <Link to="/cookie-policy">Cookies</Link>
          </nav>
        </div>
      </header>

      <main className="policy-main">
        <h1 className="policy-title">Privacy Policy</h1>
        <p className="policy-effective">Effective Date: March 6, 2026</p>
        <p className="policy-intro">
          This Privacy Policy explains how TECHXM collects, uses, and protects
          personal information when you use our website and services.
        </p>

        <section className="policy-section">
          <h2>Information We Collect</h2>
          <ul>
            <li>Contact details such as name, email address, and phone number.</li>
            <li>Business information submitted through consultation forms.</li>
            <li>Usage data, including pages visited and browser/device metadata.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>How We Use Information</h2>
          <ul>
            <li>Respond to inquiries and provide requested services.</li>
            <li>Manage projects, support, and service delivery communication.</li>
            <li>Improve website performance, reliability, and user experience.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Data Sharing</h2>
          <p>
            We do not sell personal information. We may share data with trusted
            service providers that support hosting, analytics, or communication,
            subject to confidentiality and security obligations.
          </p>
        </section>

        <section className="policy-section">
          <h2>Data Security</h2>
          <p>
            We apply reasonable technical and organizational controls to protect
            information from unauthorized access, disclosure, or misuse.
          </p>
        </section>

        <section className="policy-section">
          <h2>Your Rights</h2>
          <p>
            You may request access, correction, or deletion of your personal
            data by contacting us at{" "}
            <a href="mailto:admin@techxm.co.za">admin@techxm.co.za</a>.
          </p>
        </section>
      </main>
    </div>
  );
}





